import { useEffect, useState } from 'preact/hooks'

/** The time now in epoch milliseconds, ticking every `stepMs`: what the room's countdowns and clocks are drawn from. */
export function useNow(stepMs = 1000): number {
    const [now, setNow] = useState(() => Date.now())
    useEffect(() => {
        const timer = setInterval(() => setNow(Date.now()), stepMs)
        return () => clearInterval(timer)
    }, [stepMs])
    return now
}
